import { usePostHog } from 'posthog-js/react';
import { useCallback } from 'react';

export type MetricEvent<TypeForm> = {
  name: string;
  payload?: object;
  newFormData?: TypeForm;
  oldFormData?: TypeForm;
};

export const formatFormMetric = <TypeForm extends Record<string, unknown>>(
  oldData?: TypeForm,
  newData?: TypeForm,
) => {
  if (newData && oldData) {
    return Object.keys(newData).reduce((acc, key) => {
      if (key.includes('attachments')) return acc;
      if (JSON.stringify(newData[key]) !== JSON.stringify(oldData[key])) {
        return { ...acc, [key]: newData[key] ?? '' };
      }
      return acc;
    }, {});
  }
  return newData;
};
const useMetricEvent = () => {
  const posthog = usePostHog();
  const dispatchMetricEvent = useCallback(
    <TypeForm extends Record<string, unknown>>({
      name,
      payload,
      newFormData,
      oldFormData,
    }: MetricEvent<TypeForm>) => {
      const formattedNewData = formatFormMetric(oldFormData, newFormData);
      posthog?.capture(name, {
        ...payload,
        newData: formattedNewData,
        oldData: oldFormData,
      });
    },
    [],
  );

  return { dispatchMetricEvent };
};

export default useMetricEvent;
